import { render, staticRenderFns } from "./Lodop.vue?vue&type=template&id=5905711e&scoped=true&"
import script from "./Lodop.vue?vue&type=script&lang=js&"
export * from "./Lodop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5905711e",
  null
  
)

export default component.exports